import TraductionVerificationService from "@/integrations/service/traduction-verification.service";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { queryKeys } from "./queryKeys";

export const useTraductionsVerification = (verificationId: number) => {
  return useQuery({
    queryKey: queryKeys.traductionVerification(verificationId),
    queryFn: () => TraductionVerificationService.getAll(verificationId),
    enabled: !!verificationId,
  });
};

export const useCreateTraductionVerification = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ verificationId, payload }: { verificationId: number; payload: any }) =>
      TraductionVerificationService.create(verificationId, payload),
    onSuccess: (_, variables) => {
      qc.invalidateQueries({ queryKey: queryKeys.traductionVerification(variables.verificationId) });
      qc.invalidateQueries({ queryKey: queryKeys.verifications });
    },
  });
};

export const useUpdateTraductionVerification = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, payload }: { id: number; payload: any }) =>
      TraductionVerificationService.update(id, payload),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["traductions-verification"] });
      qc.invalidateQueries({ queryKey: queryKeys.verifications });
    },
  });
};

export const useDeleteTraductionVerification = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => TraductionVerificationService.delete(id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["traductions-verification"] });
      qc.invalidateQueries({ queryKey: queryKeys.verifications });
    },
  });
};
